export class CacheWithCalculatingMode<T> {
  private val: T
  private isCalculating = false
  private promise: Promise<void>
  private resolver: () => void

  private calculating() {
    if (this.isCalculating) return
    this.isCalculating = true
    this.val = undefined
    this.promise = new Promise(resolve => {
      this.resolver = resolve
    })
  }

  set(v: T) {
    this.val = v
    this.isCalculating = false
    this.resolver?.()
  }

  reset() {
    this.val = undefined
  }

  async get() {
    if (this.isCalculating) await this.promise
    else if (!this.val) this.calculating()
    return this.val
  }
}
